<template>
  <Loader
    v-if="isLoading"
    class="global-loader"/>
  <router-view/>
  <UserManual/>
</template>

<script setup lang="ts">
import {isLoading} from '@/shared/composables/loading.ts'
import Loader from '@/components/common/Spinner.vue'
import UserManual from '@/components/common/UserManual.vue'
</script>

<style>
.global-loader {
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
